import { SkipPrevious } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { useAppState } from "../../../../hooks/useAppState";
import { SkipButton } from "../../Controls.elements";

interface ButtonPreviousProps {
  handleClickPreviousVideo: () => void;
  disabled: boolean;
}

export default function ButtonPrevious({
  handleClickPreviousVideo,
  disabled,
}: ButtonPreviousProps): React.ReactElement {
  const { slideIdx, moduleIdx, nextModule } = useAppState();
  const isFirstSlide = slideIdx.index === 0 && moduleIdx?.index === 1;
  const isFirstSlideInModule = slideIdx.index === 0;

  const goToPrev = () => nextModule(true);

  const SkipButtonComponent = (
    <SkipButton
      disableFocusRipple={true}
      onClick={isFirstSlideInModule ? goToPrev : handleClickPreviousVideo}
      aria-label="Go to previous slide"
      id="button_previous_slide"
      disabled={isFirstSlide || disabled}
      className={isFirstSlide ? "hidden" : ""}
      sx={{
        mr: "auto",
      }}
    >
      <SkipPrevious />
    </SkipButton>
  );

  const tooltipTitle = "Previous slide (p)";

  return disabled ? SkipButtonComponent : <Tooltip title={tooltipTitle}>{SkipButtonComponent}</Tooltip>;
}
